
  var nustatymai = {
    "SERVER_IP": "10.1.1.250",
    "loadDataFromEmaitinimas": true,
    "isSeveralRaspberryIps": false
 };

 module.exports = nustatymai;
